import { z } from 'my-zod'

/**
 * Used when representing applicable tax or discount on a plan.
 * As of October 2020, we are not applying taxes to plans.
 */
export const SubscriptionPlanAmounts = z.object({
  planName: z.string(),
  zipCode: z.string().describe('The zip code this tax reflects'),
  priceAmount: z.onumber(),
  discount: z.onumber(),
  discountText: z.ostring(),
  comments: z.ostring(),
  subtotal: z.onumber(),
  tax: z.onumber(),
  total: z.onumber()
})

export type SubscriptionPlanAmounts = z.infer<typeof SubscriptionPlanAmounts>
